export const CATALOG_STOCK_UNITS_PAGE_SIZE = 10;
